export default function hasPermissionQ(permissionType, role) {
  const permissions = {
    'Teacher': ['Super Administrator', 'District Admin', 'School Admin', 'Teacher'],
    'School Admin': ['Super Administrator', 'District Admin', 'School Admin'],
    'District Admin': ['Super Administrator', 'District Admin'],
    'Super Administrator': ['Super Administrator'],
  }
  return permissions[permissionType].indexOf(role) !== -1
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/hasPermissionQ.js